export default "__VITE_ASSET__Ds8G_2Qk__"